import React from 'react';



import {
  DashboardStatCardContainer,
  DashboardStatCardContent,
  DashboardStatCardHeader,
  DashboardStatCardIconContainer,
  DashboardStatCardSecondary,
  DashboardStatCardTitle,
  DashboardStatCardValue,
  DashboardStatCardSkeletonTitle,
  DashboardStatCardSkeletonIcon,
  DashboardStatCardSkeletonValue,
  DashboardStatCardSkeletonSecondary,
} from '../../DashBoardNew/dashBoardNewStyles';

const DashboardStatCard = ({
  title,
  value,
  secondaryText = "",
  icon,
  containerProps = {},
  handleIconClick,
  isLoading,
}) => {
  const renderIcon = () => {
    if (!icon) return null;

    if (typeof icon === 'string') {
      return <img src={icon} alt={`${title} icon`} />;
    }

    return icon;
  };

  // Render skeleton loading state
  if (isLoading) {
    return (
      <DashboardStatCardContainer {...containerProps}>
        <DashboardStatCardHeader>
          <DashboardStatCardSkeletonTitle />
          {icon && <DashboardStatCardSkeletonIcon />}
        </DashboardStatCardHeader>

        <DashboardStatCardContent>
          <DashboardStatCardSkeletonValue />
          {secondaryText && <DashboardStatCardSkeletonSecondary />}
        </DashboardStatCardContent>
      </DashboardStatCardContainer>
    );
  }

  return (
    <DashboardStatCardContainer {...containerProps}>
      <DashboardStatCardHeader>
        <DashboardStatCardTitle>{title}</DashboardStatCardTitle>
        {icon && (
          <DashboardStatCardIconContainer onClick={handleIconClick}>
            {renderIcon()}
          </DashboardStatCardIconContainer>
        )}
      </DashboardStatCardHeader>

      <DashboardStatCardContent>
        <DashboardStatCardValue>{value}</DashboardStatCardValue>
        {secondaryText && (
          <DashboardStatCardSecondary>{secondaryText}</DashboardStatCardSecondary>
        )}
      </DashboardStatCardContent>
    </DashboardStatCardContainer>
  );
};

export default DashboardStatCard;